import { createFileRoute } from '@tanstack/react-router'
import { BotBuilderPage } from '@/features/bot-builder/components/BotBuilderPage'

export const Route = createFileRoute('/_auth/bot-builder')({
  component: BotBuilderPage,
})
